<template>
  <a-spin :spinning="spinning">
    <a-card>
      <a-table
        :columns="columns"
        :data-source="listData"
        childrenColumnName="subMenus"
        class="components-table-demo-nested"
      >
      </a-table>
    </a-card>
  </a-spin>
</template>

<script>
import { getMenuAll } from "@/api/api.js";
const columns = [
  { title: "菜单名称", dataIndex: "name",align:'center' },
  { title: "菜单路径", dataIndex: "path",align:'center' },
  { title: "创建时间", dataIndex: "createTime",align:'center' },
];
export default {
  name: "authorityManagement",
  created() {
    this.handleGetMenuAll();
  },
  data() {
    return {
      spinning: false,
      listData: null,
      columns,
    };
  },
  methods: {
    //查询所有菜单
    handleGetMenuAll() {
      this.spinning = true
      getMenuAll().then((res) => {
        this.spinning = false
        if (res.code == "0000") {
          this.listData = res.data.map(item =>{
             for(let i=0;i<item.subMenus.length;i++){
                if(item.subMenus[i].subMenus){
                  delete item.subMenus[i].subMenus
                }
             }
             return item
          });
          console.log(this.listData)
        
        } else {
          this.$message.warn(res.msg);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .ant-table .ant-table-row-indent + .ant-table-row-expand-icon{
  margin-left:-100px;
}
/deep/ .ant-table-tbody > tr > td:nth-of-type(1){
  display: flex;
  justify-content:space-evenly;
}
/deep/ .ant-table-thead > tr > th:nth-of-type(1){
  text-align: right !important;
  padding-right: 110px;
}
/deep/ .ant-table-row-level-1 > td:nth-of-type(1){
  margin-left: 50px !important;
}
</style>